<template>
  <div class="OrderDetailTabContainer">
    <div>
      <div class="FormGroup-Label FormGroup-Margin">
        <label>希望納期を選択してください</label>
        <span class="require-message">※必須</span>
      </div>
      <div class="FormGroup">
        <el-form
          :model="form"
          ref="shippingForm"
          :hide-required-asterisk="true"
        >
          <el-form-item
            prop="expectedShippingDate"
            :rules="[
              {
                required: true,
                message: '希望納期を選択してください',
              },
            ]"
          >
            <el-date-picker
              ref="datePicker"
              v-model="form.expectedShippingDate"
              class="FormGroup-Form"
              type="date"
              placeholder="希望納期を選択してください"

              :picker-options="pickerOptions"
              :clearable="false"
              :editable="false"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  mounted () {
    this.form.isNeededLayoutReply = true;
  },
  data () {
    return {
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
    };
  },
  computed: {
    ...mapState({
      form: state => state.orderForm.detailInput,
      defaultExpectedShippingDate: state => state.orderForm.defaultExpectedShippingDate,
    }),
  },
  watch: {},
  updated () {},
  methods: {
    /**
     * Prevent selection of dates prior to the default expected shipping date
     * @returns {boolean}
     */
    disabledDate (time) {
      if (this.defaultExpectedShippingDate) {
        const expectedShippingDate = moment(this.defaultExpectedShippingDate);
        return expectedShippingDate > time.getTime();
      }
      // query defaultExpectedShippingDate が何らかのエラーでデータが取得出来ない場合、旧ロジックにて日付入力制限を行う
      // 10営業日以降のみを選択できるようにする
      // 土日含めて10営業日とする
      return moment().add("9", "days") > time.getTime();
    },
    /**
     * function for validation of "expectedShippingDate".
     * Assumed to be called from the parent component "OrderFormStep6.module.vue".
     * @returns {boolean}
     */
    validateInput () {
      let isValid = true;
      this.$refs.shippingForm.validate(valid => {
        isValid = valid;
      });
      return isValid;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.OrderDetailTabContainer > * + * {
  margin-top: 10px;
}
.FormGroup {
  // margin-right: 7.5rem;
  justify-content: center;
}
.FormGroup-Margin {
  margin: 10px 0 0 0;
}
.require-message {
  color: $red-base; // #f56c6c;
  margin-left: 5px;
  font-size: 14px;
  line-height: 40px;
  font-weight: normal;
}
::v-deep .el-date-editor > input {
  padding-right: 0;
}
::v-deep .el-form-item .el-form-item__content .el-date-editor .el-input__inner {
  text-align: left !important;
}
</style>
